import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { GENERATION_STEPS, STEP_COUNT, getStepByPhase, getStepDescription } from '../constants/generationSteps';

const BRAND_TEAL = '#2ec4b6';

const pulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(46,196,182,0.45); }
  50%      { box-shadow: 0 0 0 6px rgba(46,196,182,0); }
`;

const DotsRow = styled(Box)({
  display: 'flex',
  gap: 8,
  justifyContent: 'center',
  alignItems: 'center',
});

const Dot = styled('div')(({ state }) => ({
  width: state === 'active' ? 32 : 10,
  height: 10,
  borderRadius: state === 'active' ? 5 : '50%',
  backgroundColor: state === 'pending' ? 'transparent' : BRAND_TEAL,
  border:
    state === 'active' ? '1px solid rgba(46,196,182,0.5)' :
    state === 'past'   ? 'none' :
                         '2px solid rgba(0,0,0,0.18)',
  transition: 'width 0.35s cubic-bezier(.4,0,.2,1)',
  animation: state === 'active' ? `${pulse} 1.8s ease-in-out infinite` : 'none',
}));

const StepCaption = styled(Typography)({
  fontFamily: 'Helvetica Inserat, Impact, sans-serif',
  fontSize: '0.75rem',
  letterSpacing: '0.32em',
  color: '#888',
  textTransform: 'uppercase',
  textAlign: 'center',
  marginTop: 18,
});

const StepLabel = styled(Typography)({
  fontFamily: 'Helvetica Inserat, Impact, sans-serif',
  fontSize: '1.8rem',
  color: '#222',
  textAlign: 'center',
  lineHeight: 1.1,
  marginTop: 4,
});

const StepDescription = styled(Typography)({
  fontSize: '0.95rem',
  color: '#5f5f5f',
  textAlign: 'center',
  marginTop: 8,
});

const StepIndicator = ({ currentPhase, categoryCount = 0 }) => {
  const currentStep = getStepByPhase(currentPhase);
  const activeIndex = currentStep.stepNumber - 1;

  return (
    <Box sx={{ mb: 3 }}>
      <DotsRow>
        {GENERATION_STEPS.map((step, index) => {
          let state = 'pending';
          if (index < activeIndex) state = 'past';
          else if (index === activeIndex) state = 'active';
          return <Dot key={step.key} state={state} data-dot={state} />;
        })}
      </DotsRow>
      <StepCaption>Step {currentStep.stepNumber} of {STEP_COUNT}</StepCaption>
      <StepLabel>{currentStep.label}</StepLabel>
      <StepDescription>{getStepDescription(currentStep, categoryCount)}</StepDescription>
    </Box>
  );
};

export default StepIndicator;
